import { render, staticRenderFns } from "./BoottomTab.vue?vue&type=template&id=7a296340&scoped=true&"
import script from "./BoottomTab.vue?vue&type=script&lang=js&"
export * from "./BoottomTab.vue?vue&type=script&lang=js&"
import style0 from "./BoottomTab.vue?vue&type=style&index=0&id=7a296340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a296340",
  null
  
)

export default component.exports